import { BsModalRef } from 'ngx-bootstrap/modal';
import { Component } from '@angular/core';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import { IVideoDetails } from './video-details';

@Component({
    selector: 'kh-watch-video',
    styleUrls: ['./watch-video.component.less'],
    templateUrl: './watch-video.component.html',
    standalone: false
})
export class WatchVideoComponent implements IVideoDetails {

  public closeIcon = faTimes;
  public title = '';
  public videoId = '';
  public description = '';

  public constructor(
    private readonly bsModalRef: BsModalRef) {
  }

  public close(): void {
    this.bsModalRef.hide();
  }
}
